import React, { forwardRef } from "react";
import { Box, Typography, Link, IconButton } from "@mui/material";
import {
  Facebook,
  Instagram,
  YouTube,
  Twitter,
  Mail,
} from "@mui/icons-material";
import logo from "../../assets/logo2.png";
import "./Footer.css";
import yellowSymbol from "../../assets/yellow-symbol-1.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

const Footer = forwardRef((props, ref) => {
  return (
    <Box
      sx={{
        bottom: 0,
        width: "100%",
        backgroundColor: "#111111",
        padding: "0px",
        display: "flex",
        flexDirection: "column",
        zIndex: 9999,
        color: "#ffffff",
      }}
      ref={ref}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "auto",
          overflow: "hidden",
        }}
      >
        <svg viewBox="0 0 1500 80" aria-hidden="true" className="custom-svg">
          <path
            d="M0,0 Q500,10 700,45 Q1200,130 1500,0"
            stroke="#ffffff"
            className="top-white"
          />
        </svg>
      </Box>

      <Box
        sx={{
          textAlign: "left",
          padding: "20px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            mb: { xs: "20px", md: 0 },
            textAlign: { xs: "center", md: "center" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "center", lg: "flex-start" },
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFD700",
              borderRadius: "4px",
              marginBottom: { xs: "10px", sm: "10px", lg: "8px" },
              flex: 1,
              width: {},
            }}
          >
            <img src={logo} alt="USM Logo" style={{ height: "100px" }} />
          </Box>
          <Box
            sx={{
              borderRadius: "4px",
              marginBottom: { xs: "10px", sm: "10px", lg: "8px" },
              flex: 1,
              display: "flex",

              gap: "10px",
              alignItems: "center",
              marginLeft: { lg: "100px" },
              marginTop: { lg: "50px" },
            }}
          >
            <LocationOnIcon fontSize="large" color="primary" />
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "16px", sm: "16px", md: "16px" },
              }}
            >
              118 College Drive #5037 <br /> Hattiesburg, MS 39406
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "4px",
              marginBottom: { xs: "10px", sm: "10px", lg: "8px" },
              flex: 1,
              display: "flex",

              gap: "10px",
              alignItems: "center",
              marginLeft: { lg: "100px" },
              marginTop: { lg: "50px" },
            }}
          >
            <PhoneIphoneIcon fontSize="large" color="primary" />
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "16px", sm: "16px", md: "16px" },
              }}
            >
              Phone <br /> 601.266.4558
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: "4px",
              marginBottom: { xs: "10px", sm: "10px", lg: "8px" },
              flex: 1,
              display: "flex",

              gap: "10px",
              alignItems: "center",
              marginTop: { lg: "60px" },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "16px", sm: "16px", md: "16px" },
                flex: 1,
              }}
            >
              <b>
                <Link
                  href="/contact-us"
                  sx={{ color: "#FFD700", textDecoration: "none" }}
                >
                  Contact and Hours
                </Link>
              </b>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: "#FFD700",
          padding: "10px 20px",
          width: "100%",
          textAlign: "left",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#000",
            textAlign: "center",
            marginTop: "10px",
            fontSize: { xs: "10px", sm: "12px", md: "14px" },
          }}
        >
          © The University of Southern Mississippi. Hattiesburg, Mississippi
          39402
        </Typography>
      </Box>
    </Box>
  );
});

export default Footer;
